import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import AddIcon from '@mui/icons-material/Add';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Fab from '@mui/material/Fab';
import GenericDataTable from '../components/Common/GenericDataTable'

import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link
} from "react-router-dom";
import AddUser from '../components/ManagementPageComponents/AddUser';


export default function AdminManagement({ initialTab }) {


    const [tabValue, setTabValue] = useState(initialTab);
    const [isDialogOpen, setIsDialogOpen] = useState();

    const handleClickOpen = () => {
        setIsDialogOpen(true)
    };

    const handleClose = () => {
        setIsDialogOpen(false)
    };



const handleTabChange = (event, newValue) => {
    setTabValue(newValue)
};




        return (
            <div>
                <Box sx={{ width: '100%' }}>
                    
                    <Tabs
                        value={tabValue}
                        onChange={handleTabChange}
                        textColor="secondary"
                        indicatorColor="secondary"
                        aria-label="robots tabs"
                    >
                        
                        <Tab tag={Link} to="/management/users" value="Users" label="Users" />
                    </Tabs>
                </Box>

                
                {
                    tabValue == "Users" &&
                    <>
                        <Dialog open={isDialogOpen} onClose={handleClose}>
                            <DialogContent>
                                <AddUser handleClose={handleClose}></AddUser>
                            </DialogContent>

                        </Dialog>

                        <Box sx={{ '& > :not(style)': { m: 1 } }}>
                            <Fab title="Add User" className="floatRight" color="primary" aria-label="add" onClick={handleClickOpen}>
                                <AddIcon />
                            </Fab>

                        </Box>
                        <GenericDataTable pageUrl="/management/users" fetchUrl={"api/getdatabase?table_name=login"} > </GenericDataTable>


                    </>
                }
                

               


            </div>
        );
    }

